// lib/registry.js
// From https://nextjs.org/docs/app/building-your-application/styling/css-in-js#styled-components
'use client'

import type React from 'react'

import { useServerInsertedHTML } from 'next/navigation'
import { useState } from 'react'
import { ServerStyleSheet, StyleSheetManager } from 'styled-components'

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function StyledComponentsRegistry({
  children,
  nonce,
}: {
  children: React.ReactNode
  nonce?: string
}): React.JSX.Element {
  // Only create stylesheet once with lazy initial state
  // x-ref: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet())

  useServerInsertedHTML(() => {
    const styles = styledComponentsStyleSheet.getStyleElement()
    styledComponentsStyleSheet.instance.clearTag()
    return <>{styles}</>
  })

  if (typeof window !== 'undefined') return <>{children}</>

  return (
    <StyleSheetManager
      sheet={styledComponentsStyleSheet.instance}
      {...(nonce ? { nonce } : {})}
    >
      {children}
    </StyleSheetManager>
  )
}
